import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  private pdfBytes: Uint8Array | null = null;

  constructor() { }

  setPdfBytes(bytes: Uint8Array) {
    this.pdfBytes = bytes;
    return this.pdfBytes;
  }

  getPdfBytes(): Uint8Array | null {
    return this.pdfBytes;
  }
}
